import { gql } from "@apollo/client";

export const USER_POOL_GET_USER_OFFERS = gql`
  query GetUserOffers($id: ID!) @client {
    userOffers: getUserOffers(id: $id) {
      id
    }
  }
`;
